/*
  Newsletter forms (snippets/newsletter-form.liquid): subscribe without a page reload.
  The form is posted with fetch; Shopify answers with the page again, and we read the result
  from it (customer_posted=true = subscribed, or the form's error message).
  If Shopify asks for a captcha (/challenge), the form is submitted normally instead.
*/
if (!window.MNewsletterForms) {
  window.MNewsletterForms = true;

  const setMessage = (wrapper, text, type) => {
    const el = wrapper.querySelector('[data-newsletter-message]');
    if (!el) return;
    el.textContent = text;
    el.classList.toggle('is-error', type === 'error');
    el.classList.toggle('is-success', type === 'success');
    el.hidden = !text;
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const wrapper = form.closest && form.closest('[data-newsletter]');
    if (!wrapper || !window.fetch) return;
    event.preventDefault();

    const button = form.querySelector('[type="submit"]');
    const input = form.querySelector('[name="contact[email]"]');
    // Old messages from a previous full-page post.
    form.querySelectorAll('.notification').forEach((el) => el.remove());
    setMessage(wrapper, '', null);
    if (button) {
      button.disabled = true;
      button.classList.add('is-loading');
    }

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      });

      if (/\/challenge/.test(response.url)) {
        form.submit();
        return;
      }

      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const returned = form.id ? doc.getElementById(form.id) : null;
      const errorEl = returned && returned.querySelector('.notification.warning .notification--error-message');
      const errorText = errorEl ? errorEl.textContent.trim().replace(/\s+/g, ' ') : '';

      if (errorText) {
        // An address that is already on the list is not a real problem for the customer.
        if (/taken|already/i.test(errorText)) {
          setMessage(wrapper, wrapper.dataset.subscribed, 'success');
          if (input) input.value = '';
        } else {
          setMessage(wrapper, errorText, 'error');
        }
      } else if (response.ok) {
        setMessage(wrapper, wrapper.dataset.success, 'success');
        if (input) input.value = '';
        form.querySelectorAll('input[type="checkbox"]').forEach((box) => {
          box.checked = false;
        });
        if (button) {
          button.classList.add('is-done');
          setTimeout(() => button.classList.remove('is-done'), 2500);
        }
      } else {
        throw new Error(`Newsletter signup failed (${response.status})`);
      }
    } catch (error) {
      console.error(error);
      setMessage(wrapper, 'Something went wrong. Please try again.', 'error');
    } finally {
      if (button) {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    }
  });
}
